import React, { useMemo, useRef } from "react";
import { Controller } from "react-hook-form";
import { RadioGroup } from "@material-ui/core";

import { FlyerDetailAddPageTemplateGroup } from "../flyer-detail-add-page-template-group/flyer-detail-add-page-template-group.compnent";
import { FlyerTemplateGroupOption } from "../../types/flyer-template-group-option/flyer-template-group-option.interface";
import { createFlyerTemplateGroupOptions } from "../../types/flyer-template-group-option/flyer-template-group-option.functions";
import { useControlForm } from "../../../../../../../../features/forms/forms.hook";
import { IFormRef } from "../../../../../../../../features/forms/types/forms.interface";
import { createFormRef } from "../../../../../../../../features/forms/types/forms.functions";
import { FlyerDetailAddPageTemplateSelectorProps } from "./flyer-detail-add-page-template-selector.props";
import { createFlyerDetailAddPageForm } from "../../types/flyer-detail-add-page-form/flyer-detail-add-page-form.functions";
import { GreenButton } from "../../../../../../../../components/form-controls/button/green-button/green-button.component";
import { HostContainer } from "./flyer-detail-add-page-template-selector.styles";
import { withShowIf } from "../../../../../../../../components/with-show-if/with-show-If.component";

export const FlyerDetailAddPageTemplateSelector = withShowIf(
  (props: FlyerDetailAddPageTemplateSelectorProps) => {
    const formRef = useRef<Partial<IFormRef>>(createFormRef());

    const templateGroupOptions = useMemo(() => createFlyerTemplateGroupOptions(props.templates), [
      props.templates,
    ]);

    const form = useControlForm({
      defaultValues: createFlyerDetailAddPageForm(),
      formRef,
    });

    const noTemplateSelected = () => form.getValues().templateId === -1;

    return (
      <HostContainer>
        <GreenButton onClick={form.handleSubmit(props.onSubmit)} disabled={noTemplateSelected()}>
          Create Page
        </GreenButton>
        <Controller
          control={form.control}
          name="templateId"
          render={(renderProps) => (
            <RadioGroup
              {...renderProps.field}
              tabIndex={-1}
              onChange={(event) => renderProps.field.onChange(Number(event.target.value))}
            >
              {templateGroupOptions.map((group: FlyerTemplateGroupOption) => (
                <FlyerDetailAddPageTemplateGroup
                  key={group.positions}
                  templateGroup={group}
                  onEnter={renderProps.field.onChange}
                />
              ))}
            </RadioGroup>
          )}
        />
      </HostContainer>
    );
  }
);
